// extracted by mini-css-extract-plugin
export default {"button":"ConfirmActionButton_button__xu9Rw"};